import { componentFactory } from '@fusioncharts/core/src/lib';
import CategoryAxis from '@fusioncharts/core/src/axis/category';
/**
 * function to instatiate axis and get attached to canvas
 * @param {Object} chart chart API
 */
export default function (chart) {
  let canvas = chart.getChildren('canvas')[0],
    axisRefVisualCartesian = canvas.getChildren('axisRefVisualCartesian')[0],
    zoomObj = {
      zoomable: true,
      pannable: true
    },
    config = chart._feedAxesRawData(),
    yAxis,
    xAxis,
    redraw = () => axisRefVisualCartesian.asyncDraw();

  componentFactory(chart, CategoryAxis, 'yAxis', 1, config.yAxisConf);
  componentFactory(chart, CategoryAxis, 'xAxis', 1, config.xAxisConf);

  yAxis = chart.getChildren('yAxis')[0];
  xAxis = chart.getChildren('xAxis')[0];
  yAxis.setLinkedItem('canvas', canvas);
  xAxis.setLinkedItem('canvas', canvas);
  axisRefVisualCartesian.setLinkedItem(yAxis.getId(), yAxis);
  axisRefVisualCartesian.setLinkedItem(xAxis.getId(), xAxis);

  axisRefVisualCartesian.addExtEventListener('visiblerangeset', redraw, xAxis);
  axisRefVisualCartesian.addExtEventListener('visiblerangeset', redraw, yAxis);

  canvas.attachAxis(xAxis, false, chart.zoomX ? zoomObj : {});
  canvas.attachAxis(yAxis, true, chart.zoomY ? zoomObj : {});

  chart._setCategories();
}
